// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1oiWh","containerItemsCenter":"Skeleton_containerItemsCenter__1fzZG"};